import React, {Component} from 'react';
import {toast} from 'react-toastify';
import {withTranslation} from 'react-i18next';
import {APIClient} from "../../../utils/APIClient";
import {URLQueryStringParser} from "../../../utils/URLQueryStringParser";
import {API_URL} from '../../../settings/local_settings';
import {Loading} from "../../Loading";


import {withRouterParams} from "../../../utils/withRouterParams";
import {DV360_CHANNEL} from '../../channels/channels';
import {consumeReconnect, forgetReconnect} from '../connections/reconnectNote';
import {
    announceReconnectNotice, destinationAfterConnect, originOf, ORIGIN_ACCOUNT, reconnectNotice, reconnectResultOf,
    recordReconnectResult,
} from '../connections/reconnectAccountText';

let oauthExchangeInFlight = false;

class ConnectDV360Account extends Component {
    constructor(props) {
        super(props);
        this.componentDidMount = this.componentDidMount.bind(this);
    }

    componentDidMount() {
        let code = new URLQueryStringParser().getUrlParams('code');
        if (!code) {
            // Volvió sin autorizar: la reconexión que estaba anotada terminó acá (contrato §2.1).
            forgetReconnect();
            this.props.history.push('/agency/conections');
            return;
        }
        try {
            const url = new URL(window.location.href);
            ['code', 'scope', 'authuser', 'prompt', 'state', 'hd'].forEach((p) => url.searchParams.delete(p));
            window.history.replaceState({}, '', url.pathname + (url.search || ''));
        } catch (e) { /* noop */ }
        if (oauthExchangeInFlight) {
            this.props.history.push('/agency/conections');
            return;
        }
        const guardKey = 'connecting_dv360_oauth_code';
        if (sessionStorage.getItem(guardKey) === code) {
            this.props.history.push('/agency/conections');
            return;
        }
        oauthExchangeInFlight = true;
        sessionStorage.setItem(guardKey, code);
        let credential_label = localStorage.getItem('pending_credential_label');
        localStorage.removeItem('pending_credential_label');
        // Qué se estaba reconectando: se consume acá, salga bien o mal, y sólo si es de DV360.
        const reconnect = consumeReconnect(DV360_CHANNEL);
        const origin = originOf(reconnect);
        const postData = {'code': code, 'credential_label': credential_label};
        if (reconnect && reconnect.adAccountId) postData.reconnect_ad_account_id = reconnect.adAccountId;
        if (reconnect && reconnect.credentialId) postData.reconnect_credential_id = reconnect.credentialId;
        const failed = () => {
            oauthExchangeInFlight = false;
            sessionStorage.removeItem(guardKey);
            // Texto propio, nunca el del backend: llega en inglés o en voseo (card 5qObKTLi).
            toast.error(this.props.t('connections.oauth.error_generic'));
            this.props.history.push('/agency/conections');
        };
        new APIClient(API_URL + 'get_access_tokens/dv360/').call('POST', postData).then((data) => {
            if (data && data.status === 'OK') {
                const result = reconnectResultOf(data);
                recordReconnectResult(DV360_CHANNEL, result, origin);
                // Desde el «Reconectar» de una cuenta vuelve al acceso que quedó (y, con un backend
                // viejo, Conexiones reasigna la cuenta). Lo demás vuelve a Conexiones, como siempre.
                this.props.history.push(origin === ORIGIN_ACCOUNT
                    ? destinationAfterConnect(DV360_CHANNEL, data, reconnect)
                    : '/agency/conections');
                const notice = reconnectNotice(this.props.t, DV360_CHANNEL, result, origin);
                if (notice) announceReconnectNotice(notice);
                else toast.success(this.props.t('connections.dv360.connected_ok'));
                return;
            }
            failed();
        }).catch(failed)
    }

    render() {
        return <Loading message={this.props.t('connections.oauth.connecting')}/>
    }
}

export default withTranslation()(withRouterParams(ConnectDV360Account));
